/**
 * nj-schedule-floor: the end-date picker's earliest pickable day is the START's own day (CC 0451).
 *
 * The picker disables any day cell before minDate's local midnight. Passing new Date(start) read the start in the
 * BROWSER's zone, so a start late in the event's day could land on the next browser day and mark the start day
 * itself "Past dates can't be picked". A same-day event then couldn't be set. The floor is read from the stored
 * string's own wall clock (as DatePicker.parseDateString does), so the start day is always pickable, in any zone.
 * The end TIME is still checked against the start by the designer's end-before-start rule.
 */
export function startDayFloor(start: string | null | undefined): Date | undefined {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(start ?? "").trim());
  if (!m) return undefined;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}
